import { render, staticRenderFns } from "./MatWeights.vue?vue&type=template&id=00b863ef&scoped=true"
import script from "./MatWeights.vue?vue&type=script&lang=js"
export * from "./MatWeights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b863ef",
  null
  
)

export default component.exports